// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  orderRequest: ['filter'],
  orderSuccess: ['data'],
  orderFailure: ['err'],

  orderCheckoutRequest: ['data'],
  orderCheckoutSuccess: null,
  orderCheckoutFailure: ['err'],

  orderConfirmRequest: ['data'],
  orderConfirmSuccess: null,
  orderConfirmFailure: ['err'],

  orderSingleRequest: ['id'],
  orderSingleSuccess: ['data'],
  orderSingleFailure: ['err'],

  orderDetailListRequest: ['filter'],
  orderDetailListSuccess: ['data'],
  orderDetailListFailure: ['err'],

  orderUpdateRequest: ['data'],
  orderUpdateSuccess: null,
  orderUpdateFailure: ['err'],

  orderUpdateAmountRequest: ['data'],
  orderUpdateAmountSuccess: null,
  orderUpdateAmountFailure: ['err'],

  orderListDownloadRequest: ['filter'],
  orderListDownloadSuccess: null,
  orderListDownloadFailure: ['err'],

  orderDetailListDownloadRequest: ['filter'],
  orderDetailListDownloadSuccess: null,
  orderDetailListDownloadFailure: ['err'],

  orderInvoiceRequest: ['data'],
  orderInvoiceSuccess: ['data'],
  orderInvoiceFailure: ['err'],

  resendOrderVoucherRequest: ['data'],
  resendOrderVoucherSuccess: ['data'],
  resendOrderVoucherFailure: ['err'],

  getOrderReportRequest: ['filter'],
  getOrderReportSuccess: ['data'],
  getOrderReportFailure: ['err'],

  getOrderReportSpreadsheetRequest: ['filter'],
  getOrderReportSpreadsheetSuccess: [null],
  getOrderReportSpreadsheetFailure: ['err'],

  getChatbotOrderRequest: ['filter'],
  getChatbotOrderSuccess: ['data'],
  getChatbotOrderFailure: ['err'],

  postChatbotOrderRequest: ['data'],
  postChatbotOrderSuccess: [null],
  postChatbotOrderFailure: ['err'],

  refundDanaRequest: ['data'],
  refundDanaSuccess: ['data'],
  refundDanaFailure: ['err']
})

export const OrderTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  data_detail: {
    data: []
  },
  DATA_REPORT: {
    data: []
  },
  DATA_CHATBOT: {
    data: []
  },
  data_single: {},
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, success: null})

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successDetailList = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_detail: data,
    err: null
  })

export const successSingle = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_single: data,
    err: null
  })

export const successReport = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    DATA_REPORT: data,
    err: null
  })

export const successChatbot = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    DATA_CHATBOT: data,
    err: null
  })

export const failureSingle = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_single: {} })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.ORDER_SUCCESS]: success,
  [Types.ORDER_REQUEST]: request,
  [Types.ORDER_FAILURE]: failure,

  [Types.ORDER_CHECKOUT_SUCCESS]: manipulateSuccess,
  [Types.ORDER_CHECKOUT_REQUEST]: manipulateRequest,
  [Types.ORDER_CHECKOUT_FAILURE]: manipulateFailure,

  [Types.ORDER_CONFIRM_SUCCESS]: success,
  [Types.ORDER_CONFIRM_REQUEST]: request,
  [Types.ORDER_CONFIRM_FAILURE]: failure,

  [Types.ORDER_SINGLE_SUCCESS]: successSingle,
  [Types.ORDER_SINGLE_REQUEST]: request,
  [Types.ORDER_SINGLE_FAILURE]: failureSingle,

  [Types.ORDER_DETAIL_LIST_SUCCESS]: successDetailList,
  [Types.ORDER_DETAIL_LIST_REQUEST]: request,
  [Types.ORDER_DETAIL_LIST_FAILURE]: failure,

  [Types.ORDER_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.ORDER_UPDATE_REQUEST]: manipulateRequest,
  [Types.ORDER_UPDATE_FAILURE]: manipulateFailure,

  [Types.ORDER_UPDATE_AMOUNT_SUCCESS]: manipulateSuccess,
  [Types.ORDER_UPDATE_AMOUNT_REQUEST]: manipulateRequest,
  [Types.ORDER_UPDATE_AMOUNT_FAILURE]: manipulateFailure,

  [Types.ORDER_LIST_DOWNLOAD_SUCCESS]: manipulateSuccess,
  [Types.ORDER_LIST_DOWNLOAD_REQUEST]: manipulateRequest,
  [Types.ORDER_LIST_DOWNLOAD_FAILURE]: manipulateFailure,

  [Types.ORDER_DETAIL_LIST_DOWNLOAD_SUCCESS]: manipulateSuccess,
  [Types.ORDER_DETAIL_LIST_DOWNLOAD_REQUEST]: manipulateRequest,
  [Types.ORDER_DETAIL_LIST_DOWNLOAD_FAILURE]: manipulateFailure,

  [Types.ORDER_INVOICE_SUCCESS]: manipulateSuccess,
  [Types.ORDER_INVOICE_REQUEST]: manipulateRequest,
  [Types.ORDER_INVOICE_FAILURE]: manipulateFailure,

  [Types.RESEND_ORDER_VOUCHER_SUCCESS]: manipulateSuccess,
  [Types.RESEND_ORDER_VOUCHER_REQUEST]: manipulateRequest,
  [Types.RESEND_ORDER_VOUCHER_FAILURE]: manipulateFailure,

  [Types.GET_ORDER_REPORT_SUCCESS]: successReport,
  [Types.GET_ORDER_REPORT_REQUEST]: request,
  [Types.GET_ORDER_REPORT_FAILURE]: failure,

  [Types.GET_ORDER_REPORT_SPREADSHEET_SUCCESS]: manipulateSuccess,
  [Types.GET_ORDER_REPORT_SPREADSHEET_REQUEST]: manipulateRequest,
  [Types.GET_ORDER_REPORT_SPREADSHEET_FAILURE]: manipulateFailure,

  [Types.GET_CHATBOT_ORDER_SUCCESS]: successChatbot,
  [Types.GET_CHATBOT_ORDER_REQUEST]: request,
  [Types.GET_CHATBOT_ORDER_FAILURE]: failure,

  [Types.POST_CHATBOT_ORDER_SUCCESS]: manipulateSuccess,
  [Types.POST_CHATBOT_ORDER_REQUEST]: manipulateRequest,
  [Types.POST_CHATBOT_ORDER_FAILURE]: manipulateFailure,

  [Types.REFUND_DANA_SUCCESS]: manipulateSuccess,
  [Types.REFUND_DANA_REQUEST]: manipulateRequest,
  [Types.REFUND_DANA_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/OrderRedux.js